import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { public: true }
  },
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/tv',
    name: 'tv',
    component: () => import(/* webpackChunkName: "tv" */ '../views/Tv.vue')
  },
  {
    path: '/teams',
    name: 'teams',
    component: () => import(/* webpackChunkName: "teams" */ '../views/Teams.vue')
  },
  {
    path: '/team/:id',
    name: 'team',
    component: () => import(/* webpackChunkName: "team" */ '../views/Team.vue')
  },
  {
    path: '/players',
    name: 'players',
    component: () => import(/* webpackChunkName: "players" */ '../views/Players.vue')
  },
  {
    path: '/matches',
    name: 'matches',
    component: () => import(/* webpackChunkName: "matches" */ '../views/Matches.vue')
  },
  {
    path: '/stats',
    name: 'stats',
    component: () => import(/* webpackChunkName: "stats" */ '../views/Stats.vue')
  },
  {
    path: '/balance',
    name: 'balance',
    component: () => import(/* webpackChunkName: "balance" */ '../views/Balance.vue')
  },
  {
    path: '/score/:id',
    name: 'score',
    component: () => import(/* webpackChunkName: "score" */ '../views/Score.vue')
  },
  {
    path: '/tables/:id',
    name: 'tables',
    component: () => import(/* webpackChunkName: "tables" */ '../views/Tables.vue')
  }
]

const router = new VueRouter({
  routes
})

// Navigation guard : rediriger vers /login si non authentifié
router.beforeEach((to, from, next) => {
  const isPublic = to.meta && to.meta.public;
  const isAuthenticated = !!sessionStorage.getItem('up_credentials');
  if (!isPublic && !isAuthenticated) {
    next({ name: 'login', query: { redirect: to.fullPath } });
  } else {
    next();
  }
});

export default router
